var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { getColumnsWidthForBreakpoint, getGridColumn } from '../helpers/grid';
import { compareBreakpoints, Breakpoints } from '../helpers/breakpoint';
import { styled } from '../theme-provider';
import { getCommonProps } from '../helpers/common-props';
const StyledContainer = styled.div.withConfig({ displayName: "StyledContainer", componentId: "sc-13ur9q2" }) `${(props) => {
    const sortedBreakpointsWithConfiguration = Object.keys(props.columns).sort(compareBreakpoints);
    const maxConfiguredBreakpoint = sortedBreakpointsWithConfiguration[sortedBreakpointsWithConfiguration.length - 1];
    const maxBreakpoint = Breakpoints.b2560;
    const maxWidthStyles = maxConfiguredBreakpoint &&
        `
			@media (min-width: ${maxBreakpoint}px) {
				min-width: ${getColumnsWidthForBreakpoint(props.columns[maxConfiguredBreakpoint], maxBreakpoint)};
				max-width: ${getColumnsWidthForBreakpoint(props.columns[maxConfiguredBreakpoint], maxBreakpoint)};
			}
		`;
    const perBreakpointStyles = sortedBreakpointsWithConfiguration
        .map((breakpoint) => {
        const columns = props.columns[breakpoint];
        const styles = `
				min-width: ${getGridColumn(columns)};
				max-width: ${getGridColumn(columns)};
			`;
        if (parseInt(breakpoint, 10) === Breakpoints.default) {
            return styles;
        }
        return `
				@media (min-width: ${breakpoint}px) {
					${styles}
				}
			`;
    })
        .join('\n');
    return `
			${perBreakpointStyles}
			${maxWidthStyles}
		`;
}} overflow:hidden;`;
export const FixedWidthContainer = (props) => {
    const { columns, children } = props, rest = __rest(props, ["columns", "children"]);
    const commonProps = getCommonProps(props);
    const breakpointConfig = typeof columns === 'number' ? { [Breakpoints.default]: columns } : columns;
    return (React.createElement(StyledContainer, Object.assign({ columns: breakpointConfig }, commonProps, rest), children));
};
